<script setup lang="ts">
import {Sharing} from "@/core/interfaces/Sharing";
import SharingStatus from "@/hospital/components/sharing/SharingStatus.vue";
import userMaleIcon from '@/assets/icons/user-male.png';
import userFemaleIcon from '@/assets/icons/user-female.png';

defineProps<{
    sharing: Sharing
}>();
</script>

<template>
  <div class="bg-white shadow rounded-lg p-4 flex justify-between">
    <div class="flex">
      <img
        v-if="sharing.sharable?.information?.gender"
        :src="sharing.sharable?.information.gender === 1 ? userMaleIcon : userFemaleIcon"
        alt="User Icon" class="w-12 h-12 rounded-full mr-4"
      >
      <div>
        <h3>{{ sharing.sharable?.information?.name }}</h3>
        <p class="text-sm text-gray-500">
          {{ sharing.tenant_name }}
        </p>
      </div>
    </div>
    <SharingStatus :status="sharing.status" class="self-start" />
  </div>
</template>

<style scoped>

</style>
